import React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { EDTextEdit } from '../../../../../../../../../../../../BaseComponents/TextEdit/EDTextEdit';
import EDCheckbox from '../../../../../../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';

const styles = (theme: Theme) => ({
  container: {},
  rightMargin: {
    marginRight: theme.spacing(2),
  },
  spacedRightMargin: {
    marginRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  hidden: {
    visibility: 'hidden',
  },
  textEdit: {
    marginBottom: 0,
  },
});

interface IProps {
  name: string;
  label: string;
  hidden?: boolean;
  rightMargin?: boolean;
  spacedRightMargin?: boolean;
  classes?: any;
}

interface IInnerProps extends IProps {
  textEditValue: number | null;
  textEditOnBlur: (value: number) => void;
  textEditOnChange: (value: number) => void;
}

interface IState {
  /** Mirrors props.textEditValue */
  oldTextEditValue: number | null;
  localValue: string;
}

const textEditToString = (textEdit: number | null): string =>
  textEdit != null ? textEdit.toString() : '';

class EkonomiskAnalysEditColumnTimeField extends React.Component<
  IInnerProps,
  IState
> {
  static getDerivedStateFromProps(props: IInnerProps, state: IState) {
    if (props.textEditValue !== state.oldTextEditValue) {
      return {
        oldTextEditValue: props.textEditValue,
        localValue: textEditToString(props.textEditValue),
      };
    }

    return null;
  }

  constructor(props: IInnerProps) {
    super(props);
    this.state = {
      localValue: textEditToString(props.textEditValue),
      oldTextEditValue: props.textEditValue,
    };
  }

  onChange = (newValue: string) => {
    this.setState({ localValue: newValue });
  };

  onBlur = () => {
    const value = this.state.localValue;

    // TODO: Parse value
    const parsedValue = Number.parseInt(value, 10);

    this.setState({ localValue: parsedValue.toString() });
    this.props.textEditOnChange(parsedValue);
    this.props.textEditOnBlur(parsedValue);
  };

  render() {
    return (
      <div
        className={classNames(this.props.classes.container, {
          [this.props.classes.spacedRightMargin]: this.props.spacedRightMargin,
          [this.props.classes.rightMargin]: this.props.rightMargin,
          [this.props.classes.hidden]: this.props.hidden,
        })}
      >
        <EDTextEdit
          label={this.props.label}
          value={this.state.localValue.toString()}
          onChange={this.onChange}
          onBlur={this.onBlur}
          disableAnimation
          tooltip={this.props.label}
        />
        <Field name={`${this.props.name}Checked`}>
          {({ value, onChange }) => (
            <EDCheckbox label="fast" checked={value} onCheck={onChange} />
          )}
        </Field>
      </div>
    );
  }
}

const EnhancedEkonomiskAnalysEditColumnTimeField: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <Field name={props.name}>
    {({ value, onChange, onBlur }) => (
      <EkonomiskAnalysEditColumnTimeField
        textEditValue={value}
        textEditOnBlur={onBlur}
        textEditOnChange={onChange}
        {...props}
      />
    )}
  </Field>
);

export default withStyles(EnhancedEkonomiskAnalysEditColumnTimeField, styles);
